import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import DashBoardRequestBody from "./DashBoardRequestBody";

export default class DashBoardService {
     request = new DashBoardRequestBody();
      static shared = new DashBoardService();

      dashBoardListRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getAllListCount(payload),
              this.request.dashBoardListRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      } 

      empDashBoardListRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getEmpTimesheets(payload),
              this.request.empDashBoardListRequest( REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      }

      dashboardMOnthlyHoursRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getDashboardMonthlyHours(payload),
              this.request.dashboardMonthlyHours(REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            }) 
            .catch((error) => {
              reject(error);
            });
        });
      }
}